import { useState, useEffect } from "react";
import { fireAdsConversion } from "@/lib/adsConversion";

const KEY = "bhgc_store_cart_v1";
const listeners = new Set();

function read() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
}
function write(items) {
  try {
    localStorage.setItem(KEY, JSON.stringify(items));
  } catch {
    /* ignore */
  }
  listeners.forEach((l) => l(items));
}

export function getCart() {
  return read();
}

export function addToCart(product, qty = 1) {
  const items = read();
  const existing = items.find((x) => x.id === product.id);
  if (existing) {
    existing.qty = Math.min(99, existing.qty + qty);
  } else {
    items.push({
      id: product.id,
      slug: product.slug,
      title: product.title,
      price: Number(product.price) || 0,
      image: product.featured_image_url || "",
      weight_kg: product.weight_kg || 1,
      qty: Math.min(99, Math.max(1, qty)),
    });
  }
  write(items);
  // Google Ads · ADD_TO_CART (producto agregado al carrito de la tienda).
  fireAdsConversion("AW-18502586718/qIFHCLC0rJYdEN6i3PZE", `add-${product.id || product.slug}`, {
    value: Number(product.price) || 0,
    currency: "MXN",
  });
}

export function setQty(id, qty) {
  const items = read();
  const i = items.find((x) => x.id === id);
  if (i) {
    i.qty = Math.max(1, Math.min(99, qty));
    write(items);
  }
}

export function removeFromCart(id) {
  write(read().filter((x) => x.id !== id));
}

export function clearCart() {
  write([]);
}

export function cartCount(items) {
  return (items || read()).reduce((s, i) => s + i.qty, 0);
}

export function cartSubtotal(items) {
  return (items || read()).reduce((s, i) => s + i.price * i.qty, 0);
}

// Hook reactivo: re-renderiza cuando el carrito cambia (mismo tab).
export function useStoreCart() {
  const [items, setItems] = useState(read);
  useEffect(() => {
    const l = (v) => setItems(v || read());
    listeners.add(l);
    // Sincroniza entre pestañas.
    const onStorage = (e) => { if (e.key === KEY) setItems(read()); };
    window.addEventListener("storage", onStorage);
    return () => {
      listeners.delete(l);
      window.removeEventListener("storage", onStorage);
    };
  }, []);
  return items;
}